import { useState } from "react";
import PropTypes from "prop-types";

// Material Design
import { IconButton, Menu, MenuItem } from "@mui/material";

// Utilities
import { ButtonTitles, Icons } from "utils/Constants";

function DprExportMenu({ dprId, isExporting, disabled, onDownloadPdf, onDownloadExcel }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const menuId = `dpr-export-menu-${dprId}`;
  const buttonId = `dpr-export-button-${dprId}`;

  const closeMenu = () => setAnchorEl(null);
  const handleSelect = (handler) => () => {
    closeMenu();
    handler();
  };

  return (
    <>
      <IconButton
        id={buttonId}
        aria-label="Export DPR"
        aria-haspopup="menu"
        aria-controls={open ? menuId : undefined}
        aria-expanded={open}
        color="info"
        disabled={disabled}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        {isExporting ? Icons.LOADING : Icons.EXPORT}
      </IconButton>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={open}
        onClose={closeMenu}
        MenuListProps={{ "aria-labelledby": buttonId }}
      >
        <MenuItem onClick={handleSelect(onDownloadPdf)}>{ButtonTitles.DOWNLOAD_PDF}</MenuItem>
        <MenuItem onClick={handleSelect(onDownloadExcel)}>{ButtonTitles.DOWNLOAD_EXCEL}</MenuItem>
      </Menu>
    </>
  );
}

DprExportMenu.propTypes = {
  dprId: PropTypes.string.isRequired,
  isExporting: PropTypes.bool,
  disabled: PropTypes.bool,
  onDownloadPdf: PropTypes.func.isRequired,
  onDownloadExcel: PropTypes.func.isRequired,
};

DprExportMenu.defaultProps = {
  isExporting: false,
  disabled: false,
};

export default DprExportMenu;
